import styled from "styled-components"

import { maxWidth } from "utils"

import { Box } from "../shared/box"

export const RecordedChatMessageContainer = styled.div`
  width: 40rem;
  height: 60rem;
  padding: 1.5rem 1.5rem 4rem 1.5rem;
  background: ${({ theme }) => theme.colors.webinar.chatBackground};
  border-radius: 0.8rem;

  ${maxWidth.tablet`
    margin: 2rem;
    width: 80%;
    height: 45rem;
  `}
`

export const VideoWithChatContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 2rem;
  padding: 2rem 0 6rem 0;

  ${maxWidth.tablet`
    flex-direction: column;
  `}
`

export const ContentfulVideoContainer = styled(Box)`
  width: 80%;
  height: 100%;

  ${maxWidth.tablet`
    width: 100%;
    padding:0;
  `}
`
